import { z } from 'zod'

import { paymentOrderSchema } from '@/features/veluvit/schemas/payment.schema'

const rawOrdersSchema = z.union([
  z.array(z.unknown()),
  z.object({ orders: z.array(z.unknown()) }),
])

export const paymentOrdersReadSchema = rawOrdersSchema
  .transform((value) =>
    (Array.isArray(value) ? value : value.orders).filter(
      (row) =>
        paymentOrderSchema.safeParse(row).success ||
        !z
          .looseObject({ id: z.string().min(1), provider: z.literal('test') })
          .safeParse(row).success
    )
  )
  .pipe(z.array(paymentOrderSchema))
